<template src="./Translations.html"></template>

<script>
    import VueResizable from 'vue-resizable';
    import translationsTopMenu from "@/components/translations/components/topMenu";
    import Pagination from "@/components/components/pagination";
    import { createNamespacedHelpers } from 'vuex';
    import {config} from "@/config";

    const { mapGetters, mapActions} = createNamespacedHelpers('translations/translations');

    export default {
        name: "Translations",
        components: {
            VueResizable,
            translationsTopMenu,
            Pagination
        },
        data() {
            return {
                cellDetailText: '',
                cellDetailLink: '',
                cellDetailLinkList: [],
                windowHeight: false,
                mainTableTop: false,
                mainErrorTableTop: false,
                hostApi: config.apiUrl,
                tabScrollStyle: {
                    width: '1920px',
                    height: '400px',
                    float: 'none'
                },
                resizeWidth: '1920px',
                idSign: false,
                idToSign: false,
                options: [
                    { value: '=', text: '=' },
                    { value: '>', text: '>' },
                    { value: '<', text: '<' }
                ],
                filterData: {},
                rangeFilterData: {},
                idFilter: null,
                idToFilter: null,
                showOverlay: 0,
                isReplace: true
            }
        },
        methods: {
            ...mapActions([
                'GET_ALL',
                'TRANSLATE',
            ]),

            markCell: function (event) {
                // toggle focus of cell
                console.log(event.target);
                const textEl = this.$refs.mainTable.$el;
                const selectedEl = textEl.querySelector('.selectedCall');
                if (selectedEl != null) {
                    selectedEl.classList.remove('selectedCall');
                }
                event.target.classList.add('selectedCall');
                this.$nextTick(() => {
                  this.windowResize();
                });
            },
            markCellSpan: function (ref) {
                // toggle focus of cell
                const textEl = this.$refs.mainTable.$el;
                const selectedEl = textEl.querySelector('.selectedCall');
                if (selectedEl != null) {
                    selectedEl.classList.remove('selectedCall');
                }
                this.$refs[ref].classList.add('selectedCall');
                this.$nextTick(() => {
                  this.windowResize();
                });
            },
            showCellContent: function (text) {
                // show detail
                this.cellDetailLink = '';
                this.cellDetailText = '';
                this.cellDetailLinkList = [];
                if (text.indexOf('http') !== -1) {
                    this.cellDetailLink = text;
                } else {
                    this.cellDetailText = text;
                }
                this.$nextTick(() => {
                  this.windowResize();
                });
            },
            showPhotoPdf: function (value) {
                // show detail
                this.cellDetailLink = '';
                this.cellDetailText = '';
                this.cellDetailLinkList = value;
            },
            goToPage: function (page) {
                this.$store.commit('translations/translations/CURRENT_PAGE', page);
                this.translationUpdate();
            },
            perPage: function (page) {
                this.$store.commit('translations/translations/PAGE_SIZE', page);
                this.translationUpdate();
            },
            widthTab: function () {
                this.tabScrollStyle.width = (window.innerWidth - 190) + 'px';
                this.resizeWidth = (window.innerWidth - 190) + 'px';
            },
            getCommentTitle: function (data) {
                if (data.field.key.indexOf('additional_') != -1) {
                    let number = data.field.key.replace('additional_', '');
                    return data.item['comment_' + number] != null ? data.item['comment_' + number] : '';
                }

                return '';
            },
            setFilter: function (changeKey = null) {
              if (changeKey != null && (
                  this.rangeFilterData[changeKey] == undefined
                  || this.rangeFilterData[changeKey] == null
                  || this.rangeFilterData[changeKey] == '')
              ) {
                return false;
              }
                this.$store.commit('translations/translations/CURRENT_PAGE', 1)
                this.$store.commit('translations/translations/FILTER_DATA', this.filterData);
                this.$store.commit('translations/translations/RANGE_FILTER_DATA', this.rangeFilterData);
                this.translationUpdate();
            },
            initPageSize: function () {
                let winHeight = window.innerHeight;
                winHeight = Math.round((winHeight - 360) / 24.5);
                console.log(winHeight)
                this.$store.commit('translations/translations/PAGE_SIZE', winHeight);
            },
            sortingChanged: function (ctx) {
                this.$store.commit('translations/translations/CURRENT_SORT_DIR', ctx.sortDesc ? 'desc' : 'asc');
                this.$store.commit('translations/translations/CURRENT_SORT', ctx.sortBy);
                this.translationUpdate();
            },
          checkIsMultiLang: function (fieldName) {
              for (let key in this.MULTI_LANG_FIELDS_LIST) {
                if (fieldName.indexOf(this.MULTI_LANG_FIELDS_LIST[key] +'-') !== -1) {
                  return true;
                }
              }
              return false;
          },
          translationSelect: function (fieldName) {
            this.$store.commit('translations/translations/SOURCE_FIELD', fieldName);
          },
          cancelSelected: function () {
            this.translationSelect(null);
          },
          isTarget: function (fieldName) {
              if (
                  this.SOURCE_FIELD == null
                  || this.SOURCE_FIELD == fieldName
                  || this.TARGET_FIELD != null
                  || fieldName == 'dimension_type'
              ) {
                return false;
              }
              let fieldBase = null;
              for (let key in this.MULTI_LANG_FIELDS_LIST) {
                if (this.SOURCE_FIELD.indexOf(this.MULTI_LANG_FIELDS_LIST[key] +'-') !== -1) {
                  fieldBase = this.MULTI_LANG_FIELDS_LIST[key];
                  break;
                }
              }

              return (fieldName.indexOf(fieldBase) !== -1);
          },
          selectTarget: function (fieldName) {
            this.$store.commit('translations/translations/TARGET_FIELD', fieldName);
            this.$store.commit('translations/translations/CURRENT_PAGE', 1);
            this.translationUpdate();
          },
          targetCancel: function () {
            this.selectTarget(null);
          },
          translate: function () {
            this.TRANSLATE({th: this});
          },
          translationUpdate: function () {
            this.GET_ALL({th: this});
          },
          windowResize: function () {
            this.windowHeight = window.innerHeight;
            this.$nextTick(() => {
              this.setMainTableTop();
              this.tabScrollStyle.height = (this.windowHeight - this.mainTableTop + 5) + 'px';
            });
          },
          setMainTableTop: function () {
            if (this.mainTableTop !== false) {
              let rect = this.$refs.mainTable.$el.getBoundingClientRect();
              this.mainTableTop = rect.top;
            } else {
              this.mainTableTop = 191;
            }
          },
        },
        computed: {
            ...mapGetters([
                'GOODS_LIST',
                'CURRENT_PAGE',
                'AMOUNT_PAGE',
                'COUNT_ROW',
                'FIELDS_LIST',
                'MULTI_LANG_FIELDS_LIST',
                'SOURCE_FIELD',
                'TARGET_FIELD',
                'IS_REPLACE',
                'PAGE_SIZE',
            ]),
            getFieldsList: function () {
                var fields = [];
                this.FIELDS_LIST.forEach((val) => {
                    fields.push({
                        key: val.key,
                        label: val.label,
                        sortable: true
                    });
                });
                return fields;
            }
        },
        mounted: function () {
            if (this.$store.getters.getAllowSection.indexOf('translations') === -1) {
                this.$router.push({ name: 'permissionDenied'});
                return;
            }
            if (this.FIELDS_LIST.length == 0) {
              this.translationUpdate();
            }
          this.widthTab();
          this.windowResize();
        },
        created() {
            window.addEventListener("resize", this.widthTab);
            window.addEventListener("resize", this.windowResize);
            this.initPageSize();
        },
        destroyed() {
          window.removeEventListener("resize", this.windowResize);
        },
        watch: {
          isReplace(newVal) {
            this.$store.commit('translations/translations/IS_REPLACE', newVal);
          }
        },
    }
</script>

<style scoped>
    .tab-width {
        width: 10000px;
    }
    .tab-scroll {
        overflow-x: scroll;
        width: 1920px;
    }
    .t-cell {
        overflow: hidden;
        display: block;
        height: 23px;
        font-size: 0.9rem;
        padding: 0 0.2rem;
    }
    .resizable-component {
        overflow-y: hidden;
        overflow-x: hidden;
        background-color: #e9ecef;
        padding: 0.5rem;
        text-align: left;
        font-size: 0.9rem;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        margin: 0;
    }
    .cell-detail.resizable-content {
        background-color: #e9ecef;
    }
    .cell-cursor {
        cursor: cell;
        padding: 1px;
    }
    .cell-cursor:hover {
        border: solid 1px grey;
        padding: 0;
    }
    .cell-cursor.selectedCall {
        border: solid 2px #007bff;
        padding: 0;
    }
    .name-coll-selected {
        font-size: 0.8rem;
        display: block;
    }
    .common-head-cell {
        height: 4rem;
        display: block;
        text-align: center;
        padding: 0 0.2rem;
    }
    .index-call {
        vertical-align: middle;
    }
    .t-head-cell.number-head {
        display: block;
    }
    .text-align-left {
        text-align: left;
    }
    .text-align-right {
        text-align: right;
    }
    .resizable-content {
        height: 100%;
        width: 100%;
        background-color: aqua;
    }
    .b-table-sticky-header, .table-responsive, [class*="table-responsive-"] {
        margin-bottom: 0;
    }
    .apply-cancel-import {
        width: 150px;
    }
    .pagination-box {
        overflow: auto;
    }
    .tableShadow i {
      background-color: grey;
    }
    i.noBackground {
      background: none;
    }
    .pagination-box ul {
      padding-bottom: 0;
      margin-bottom: 0;
    }
    .table {
      margin-bottom: 0;
    }
</style>

<style>
    .table th, .table td {
        padding: 0;
        vertical-align: middle;
    }
    .goods-import html {
        overflow-x: hidden;
    }
</style>